module.exports = __webpack_public_path__ + "static/media/ZillaSlab-BoldItalic.b01cb274.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-BoldItalic.eot
// module id = 2992
// module chunks = 68